import { Cell } from '@pelckmans/elementis/components/table';
import useTableData, { TocNodeRowHeader } from '../../hooks/useTableData';
import NodeResultCell from './components/NodeResultCell';
import NodeRowHeader from './components/NodeRowHeader';
import { useMemo } from 'react';
import { formatDuration } from '../../../../../../../utils/formatDate';
import TimeIcon from '@pelckmans/elementis/icons/time';
import { Member } from '../../../../../../../api/groups';

interface Props {
  isCollapsed: boolean;
  toggleCollapsed: () => void;
  member: Member;
  node: TocNodeRowHeader;
  getResult: ReturnType<typeof useTableData>['getResultForTocNode'];
}

export default function SingleMemberTocNodeRow({ isCollapsed, member, node, toggleCollapsed, getResult }: Props) {
  const aggregatedResult = useMemo(() => getResult(member.id, node.id), [getResult, member.id, node.id]);
  const { duration } = aggregatedResult;

  return (
    <tr>
      <NodeRowHeader node={node} isCollapsed={isCollapsed} toggleCollapsed={toggleCollapsed} />
      <NodeResultCell key={member.id} {...aggregatedResult} />
      <Cell highlighted />
      <Cell highlighted />
      <Cell highlighted>
        {duration ? (
          <Cell.Text
            title={formatDuration({ seconds: duration }, 'HH:mm')}
            startAdornment={<TimeIcon data-testid="time-icon" />}
          />
        ) : null}
      </Cell>
      <Cell highlighted />
      <Cell highlighted />
    </tr>
  );
}
